import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IChargeMasterModel } from "src/app/models/Charge_Master_Model/charge-master";
import { HSNSAC } from "src/app/models/Charge_Master_Model/hsn-sac";
import { BackendListModel } from "src/app/models/common/list.model";
import { ApiRoutes } from "../apiroutes";
import { IChargeCategory } from "src/app/components/master-data/charge-category-form/charge-category.model";
import { IChargeGroup } from "src/app/models/Charge_Master_Model/charge-group";
@Injectable({
  providedIn: 'root'
})
export class ChargeMasterApiService {
  base_url = ApiRoutes.ChargeMaster;

  constructor(private http: HttpClient) { }

  getChargeCategory(): Observable<BackendListModel<IChargeCategory>> {
    let url = `${this.base_url}charge_category_master/`;
    return this.http.get<BackendListModel<IChargeCategory>>(url);
  }

  getChargeGroup(): Observable<BackendListModel<IChargeGroup>> {
    let url = `${this.base_url}charge_group/`;
    return this.http.get<BackendListModel<IChargeGroup>>(url);
  }
  getChargeMaster(page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<IChargeMasterModel>> {
    let url = `${this.base_url}charge_master/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append('search', String(search));
    urlObj.searchParams.append('o', String(order));


    return this.http.get<BackendListModel<IChargeMasterModel>>(String(urlObj));
  }
  getChargeMasterbyID(chargeId: string) {
    let url = `${this.base_url}charge_master/${chargeId}/`;
    return this.http.get<IChargeMasterModel>(url);
  }
  //  getChargeGrouprbyID(chargeId: string) {
  //   let url = `${this.base_url}charge_group/${chargeId}/`;
  //   return this.http.get<ChargeGroup>(url);
  //  }
  getChargeGrouprbyID(chargeGroupId: string): Observable<BackendListModel<IChargeGroup>> {
    let url = `${this.base_url}charge_group/${chargeGroupId}/`;
    return this.http.get<BackendListModel<IChargeGroup>>(url);
  }
  postChargeMaster(charge: IChargeMasterModel) {
    let url = `${this.base_url}charge_master/`;
    return this.http.post<IChargeMasterModel>(url, charge);
  }
  updateChargeMaster(chargeId: string, data: IChargeMasterModel) {
    let url = `${this.base_url}charge_master/${chargeId}/`;
    return this.http.put<IChargeMasterModel>(url, data);
  }
  postChargeGroup(charge) {
    let url = `${this.base_url}charge_group/`;
    return this.http.post(url, charge);
  }

  postChargeCategory(data) {
    let url = `${this.base_url}charge_category_master/`;
    return this.http.post(url, data);
  }

  putUserChargeMapping(chargeId, data) {
    let url = `${this.base_url}charge_user_mapping/${chargeId}/`;
    return this.http.put(url, data);
  }

  postExternalSourceChargeIDMapping(chargeId, data) {
    let url = `${this.base_url}charge_external_app_mapping/${chargeId}/`;
    return this.http.post<any[]>(url, data);
  }


}
